
export default {
  namespaced: true,
  state: {
    steps: [],
    orderTempData: null
  },
  mutations: {
    setOrderTempData (state, data) {
      state.orderTempData = data
    },
    setOrderManagementListViewTour (state) {
      state.steps = [
        {
          name: 'TourOrderListView',
          target: '[data-v-step="TourOrderListView-1"]',
          params: {
            enableScrolling: false,
            placement: 'bottom'
          }
        },
        {
          name: 'TourOrderListView',
          target: '[data-v-step="TourOrderListView-2"]',
          params: {
            enableScrolling: false,
            placement: 'bottom'
          }
        },
        {
          name: 'TourOrderListView',
          target: '[data-v-step="TourOrderListView-3"]',
          params: {
            enableScrolling: false,
            placement: 'top'
          }
        },
        {
          name: 'TourOrderListView',
          target: '[data-v-step="TourOrderListView-4"]',
          params: {
            enableScrolling: false,
            placement: 'bottom'
          }
        },
        {
          name: 'TourOrderListView',
          target: '[data-v-step="TourOrderListView-5"]',
          params: {
            placement: 'top'
          }
        }
      ]
    },
    setOrderManagementCalendarViewTour (state) {
      state.steps = [
        {
          name: 'TourOrderCalendarView',
          target: '[data-v-step="TourOrderCalendarView-1"]',
          params: {
            enableScrolling: false,
            placement: 'bottom'
          }
        },
        {
          name: 'TourOrderCalendarView',
          target: '[data-v-step="TourOrderCalendarView-2"]',
          params: {
            enableScrolling: false,
            placement: 'bottom'
          }
        }
      ]
    },
    setOrderManagementKanbanViewTour (state) {
      state.steps = [
        {
          name: 'TourOrderKanbanView',
          target: '[data-v-step="TourOrderKanbanView-1"]',
          params: {
            enableScrolling: false,
            placement: 'bottom'
          }
        }
      ]
    },
    setOrderManagementDetailsTour (state) {
      state.steps = [
        {
          name: 'TourOrderDetails',
          target: '[data-v-step="TourOrderDetails-1"]',
          params: {
            enableScrolling: false,
            placement: 'bottom'
          }
        },
        {
          name: 'TourOrderDetails',
          target: '[data-v-step="TourOrderDetails-2"]',
          params: {
            enableScrolling: false,
            placement: 'bottom'
          }
        },
        {
          name: 'TourOrderDetails',
          target: '[data-v-step="TourOrderDetails-3"]',
          params: {
            enableScrolling: false,
            placement: 'bottom'
          }
        },
        {
          name: 'TourOrderDetails',
          target: '[data-v-step="TourOrderDetails-4"]',
          params: {
            enableScrolling: false,
            placement: 'bottom'
          }
        },
        {
          name: 'TourOrderDetails',
          target: '[data-v-step="TourOrderDetails-5"]',
          params: {
            placement: 'bottom'
          }
        }
      ]
    },
  },
  getters: {
    getSteps (state) {
      return state.steps
    },
    getOrderTempData (state) {
      return state.orderTempData
    }
  }
}